import { GameBookTemplateState, GameBookTemplateValues } from '@orientaction/types';

interface GameBookTemplateAction {
  type: string;
  payload?: { field: keyof GameBookTemplateValues; value: unknown } | Partial<GameBookTemplateValues>;
}

const INITIAL_STATE: GameBookTemplateState = {
  values: {
    contentForType1: 'normal',
    contentForType2: 'normal',
    citationAuthor1: '',
    citationAuthor2: '',
    citationContent1: '',
    citationContent2: '',
    p1: '',
    p2: '',
    informationEncyclopedia1: '',
    informationEncyclopedia2: '',
  },
};

const gameBookTemplateReducer = (
  state: GameBookTemplateState = INITIAL_STATE,
  action: GameBookTemplateAction,
): GameBookTemplateState => {
  switch (action.type) {
    case 'UPDATE_FIELD': {
      const { field, value } = action.payload as { field: string; value: unknown };
      return {
        ...state,
        values: { ...state.values, [field]: value },
      };
    }

    case 'SET_ALL_VALUES':
      return {
        ...state,
        values: {
          ...state.values,
          ...(action.payload as Partial<GameBookTemplateValues>),
        },
      };

    case 'RESET_VALUES':
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default gameBookTemplateReducer;
